import React from 'react';
import DocumentBrowser from '../components/documents/DocumentBrowser';

const HUB_PATH = '/inspections/new';
const IN_PROGRESS_PATH = '/inspections/new/in-progress';

const InspectionsInProgress = () => (
  <DocumentBrowser
    scope="inspections"
    status="in-progress"
    showPending
    returnTo={IN_PROGRESS_PATH}
    completedReturnTo={HUB_PATH}
    inProgressReturnTo={IN_PROGRESS_PATH}
    rowTitle="Inspection"
    placeholder="Search in progress"
    emptyText="No inspections in progress."
  />
);

export default InspectionsInProgress;
